/*eslint no-undef: "off"*/

const isShown = ref(false)
let handlersRegistered = false
let notifyAudio = null
let modalObserverStarted = false

// Pylon's widget is (or contains) an iframe, and browsers can visually paint
// iframes above other content regardless of CSS z-index. So when an app
// modal opens while Pylon is open, Pylon visually covers the modal even
// though clicks correctly go to the modal underneath — leaving Pylon's own
// controls (like its close button) unreachable. Hiding Pylon whenever any
// modal is open avoids the mismatch entirely.
function hidePylonWhileModalsAreOpen() {
    if (modalObserverStarted || typeof document === 'undefined') return
    modalObserverStarted = true

    const OPEN_MODAL_SELECTOR = '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]'

    const observer = new MutationObserver(() => {
        if (isShown.value && document.querySelector(OPEN_MODAL_SELECTOR)) {
            hide()
        }
    })

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-state'],
    })
}

function show() {
    window.Pylon('show')

    isShown.value = true
}

function hide() {
    window.Pylon('hide')

    isShown.value = false
}

function toggle() {
    if (isShown.value) {
        hide()

        return
    }

    show()
}

export function usePylon() {
    function init({ email = null, full_name: name = null, pylon_email_hash = null } = {}) {
        if (email && name) {
            window.pylon = {
                chat_settings: {
                    app_id: import.meta.env.VITE_PYLON_APP_ID,
                    email,
                    name,
                    ...(pylon_email_hash && { email_hash: pylon_email_hash }),
                },
            }
        }

        if (!handlersRegistered) {
            window.Pylon('onShow', () => {
                isShown.value = true
            })
            window.Pylon('onHide', () => {
                isShown.value = false
            })
            window.Pylon('onChangeUnreadMessagesCount', (unreadCount) => {
                if (unreadCount > 0) {
                    show()
                    if (!notifyAudio || notifyAudio.ended) {
                        notifyAudio = new Audio('/audio/notify.mp3')
                        notifyAudio.play().catch((error) => console.warn('Audio notification failed:', error))
                    }
                }
            })

            handlersRegistered = true
        }

        hidePylonWhileModalsAreOpen()
    }

    return {
        init,
        show,
        hide,
        toggle,
        isShown,
    }
}
